import { Box, Button, styled, Theme } from '@mui/material';

import { FileField } from 'theSource/components/Form';

export const IdCardAddUploadWrapperStyled = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
});

export const IdCardUploadButtonStyled = styled(Button)(
  ({ theme, $error }: { theme: Theme; $error: boolean }) => ({
    borderRadius: theme.shape.borderRadius,
    border: `0.2rem dashed ${
      $error ? theme.palette.error.main : theme.palette.primaryDark.main
    }`,
    backgroundColor: theme.palette.grey[200],
    color: theme.palette.primaryDark.main,
    minHeight: '18rem',
    display: 'flex',
    padding: 0,
    '&:focus': {
      backgroundColor: theme.palette.grey[200],
    },
    '.MuiTouchRipple-child': {
      backgroundColor: theme.palette.grey[200],
    },
  })
);

export const LabelStyled = styled('label')({
  width: '100%',
  minHeight: '18rem',
  cursor: 'pointer',
});

export const PlaceholderWrapperStyled = styled(Box)({
  width: '100%',
  minHeight: '18rem',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

export const LabelWrapperStyled = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  padding: theme.spacing(3, 4),
}));

export const FileFieldStyled = styled(FileField)({
  display: 'none',
}) as typeof FileField;
